/**
 * The MEANING map (strict grammar, ruled 2026-08-06): every semantic
 * color in the product resolves HERE, and both worlds read it -- the
 * antd surfaces through the strata components, the hand-rendered
 * canvas directly (the canvas is a projection of the grammar, not an
 * exception). A hex that means something never appears anywhere else.
 */
import { ACCENT, CATEGORICAL, INK, REDLINE } from '../theme';

/** Compliance is binary. Violating's red is the ONLY red that means
 * "breach" -- redline geography, findings, counts, all of it. */
export const VERDICT = {
  complying: ACCENT.green,
  violating: REDLINE,
} as const;
export type VerdictState = keyof typeof VERDICT;

/** Absence is loud but it is NOT violation: UNPRICED, UNVERIFIED,
 * NULL, proxy classifications all wear this one amber. */
export const ABSENCE = ACCENT.amber;

/** Element identity: color follows the entity's category, never its
 * rank. One palette for the canvas, the legend, the overview dots,
 * and the review queue -- a category never changes clothes. */
export const CATEGORY: Record<string, string> = {
  ELECTRICAL: CATEGORICAL[0],
  PLUMBING: CATEGORICAL[1],
  MECHANICAL: CATEGORICAL[2],
  ARCHITECTURAL: CATEGORICAL[3],
};
export const CATEGORY_DEFAULT = INK.muted;

/** Revision deltas (the diff module's four buckets). */
export const DELTA = {
  added: ACCENT.green,
  modified: ACCENT.amber,
  removed: ACCENT.red,
  unchanged: INK.muted,
} as const;
